import AsyncStorage from '@react-native-async-storage/async-storage'

import * as _cmCPT from './_cmCPT';

import * as _hm from './_hm';
import * as _ht from './_ht';

export const rmvAllAsync = () => new Promise( _exit1 => { // clear : remove all items.
  AsyncStorage.clear()
  .then( () => _exit1(true))
  .catch( () => _exit1(false))
});

export const chkAsync = () => new Promise<_ht.b>( _exit1 => { // asyncstorage ( = cookie を利用可能かの確認 )
    const _key = 'CheckAsyncStorage';
    const _val = 'Enabled'
    setAsync(_key, _val)
    .then( _b => {
      if ( _b == true ) {
        getAsync(_key)
        .then( _j => {
          if ( _j == _val ) {
            rmvAsync(_key)
            .then(() => _exit1(true))
            .catch( () => _exit1(false));
          }
          else {
            _exit1(false);
          }
        });
      }
      else {
        _exit1(false);
      }
    })
    .catch( () => _exit1(false));
});

export const rmvAsync = (
  pKey: _ht.s
): Promise<_ht.b> => new Promise( _exit1 => { // remove
  const _key = _hm.cvtHash(pKey);
  AsyncStorage.removeItem(_key)
  .then( () => _exit1(true))
  .catch( () => _exit1(false))
});

//const _srt = 'aobjfR{}buajoifek!SZ_{}SFG#'.f(icv.appName, icv.appName); // app ごとに異なる srt とする

export const getAsync = (
  pKey: _ht.s,
  pSrt?: _ht.s
): Promise<_ht.a|null> => new Promise( _exit1 => {
  const _key = _hm.cvtHash(pKey);
  AsyncStorage.getItem(_key)
  .then( (_s: _ht.a) => {
    _exit1(_hm.j(_cmCPT.dct(_s ?? '', pSrt)))
  })
  .catch( () => _exit1(null));
});

export const setAsync = (
  pKey: _ht.s, 
  pVle: _ht.a,
  pSrt?: _ht.s,
): Promise<_ht.b> => new Promise( _exit1 => {
  const _key = _hm.cvtHash(pKey);
  const _vle = _cmCPT.ect(_hm.s(pVle), pSrt);
  AsyncStorage.setItem(
    _key,
    _vle, 
  )
  .then(() => _exit1(true))
  .catch(() => _exit1(false))
});
